module.exports = __webpack_public_path__ + "img/31.80d3c4fd.png";